/* Pre-launch page background audio.
   Autoplay policy: nothing plays without a user gesture, so a fresh load always
   paints the OFF state and the first pointerdown/keydown anywhere on the page
   arms playback. The <audio> carries no src until then, which is also what
   keeps a reduced-data visitor from paying for the file. */
(function () {
  var button = document.querySelector('[data-password-audio]');
  var el = document.querySelector('[data-password-audio-el]');
  if (!button || !el) return;

  var KEY = 'cm:password-audio';
  var TARGET = 0.6;
  var RAMP = 800;

  var loaded = false;
  var ramp = null;

  function pref() {
    try { return sessionStorage.getItem(KEY); } catch (e) { return null; }
  }
  function remember(value) {
    try { sessionStorage.setItem(KEY, value); } catch (e) {}
  }

  /* Both labels are in the DOM; which one is visible is CSS on aria-pressed,
     so the state flip moves nothing and costs no layout shift. */
  function paint(on) {
    button.setAttribute('aria-pressed', String(on));
  }

  function volume(v) {
    try { el.volume = v; } catch (e) {}
  }

  function stopRamp() {
    if (ramp) { cancelAnimationFrame(ramp); ramp = null; }
  }

  function rampUp() {
    stopRamp();
    volume(0);
    var t0 = performance.now();
    (function step(now) {
      var k = Math.min(1, (now - t0) / RAMP);
      volume(TARGET * k);
      ramp = k < 1 ? requestAnimationFrame(step) : null;
    })(t0);
  }

  function load() {
    if (loaded) return;
    loaded = true;
    var src = el.getAttribute('data-src');
    if (src) el.src = src;
  }

  function play() {
    load();
    rampUp();
    var p = el.play();
    if (p && p.then) {
      p.then(function () { paint(true); }).catch(function () {
        stopRamp();
        paint(false);
      });
    } else {
      paint(true);
    }
  }

  function pause() {
    stopRamp();
    el.pause();
    paint(false);
  }

  paint(false);

  /* The control itself: an explicit toggle, and the only thing that writes a
     preference. `arm` below ignores gestures that land on it — stopPropagation
     could not do that job, because the document listener captures first. */
  button.addEventListener('click', function () {
    if (el.paused) { remember('on'); play(); }
    else { remember('off'); pause(); }
  });

  /* First gesture anywhere. Passive and non-cancelling, so the signup form,
     the ENTER control and the policy dialog behave exactly as before. */
  var armed = false;
  function arm(e) {
    if (armed) return;
    if (e && e.target && e.target.nodeType && button.contains(e.target)) return;
    armed = true;
    document.removeEventListener('pointerdown', arm, true);
    document.removeEventListener('keydown', arm, true);
    if (pref() === 'off') return;
    remember('on');
    play();
  }
  document.addEventListener('pointerdown', arm, { capture: true, passive: true });
  document.addEventListener('keydown', arm, { capture: true, passive: true });

  /* Opportunistic autoplay: browsers that already trust this origin (desktop
     Chrome after prior engagement) start immediately; everywhere else the
     promise rejects, nothing paints ON, and the first gesture takes over. */
  if (pref() !== 'off') {
    load();
    var attempt = el.play();
    if (attempt && attempt.then) {
      attempt.then(function () { armed = true; rampUp(); paint(true); }).catch(function () { paint(false); });
    }
  }

  window.CMPasswordAudio = {
    el: el,
    play: play,
    pause: pause,
    state: function () {
      return { paused: el.paused, volume: el.volume, src: el.currentSrc || el.src || '', pref: pref() };
    }
  };
})();
